import { Severity } from "@cayo/shared/api/types/cayo-graph";
import { RequestStatus } from "./types";

export function requestStatusToSeverity(status: RequestStatus): Severity {
  switch (status) {
    case "pending":
      return "informational";

    case "running":
      return "informational";

    case "completed":
      return "success";

    case "cancelled":
      return "warning";

    case "error":
      return "error";

    default:
      return "success";
  }
}
